<template>
  <input
    type="text"
    class="grow bg-neutral-800 px-2 text-green-100 focus:outline-none"
  />
</template>
